import { render, staticRenderFns } from "./vip-birthday-gift.vue?vue&type=template&id=2388562c&scoped=true"
import script from "./vip-birthday-gift.vue?vue&type=script&lang=js"
export * from "./vip-birthday-gift.vue?vue&type=script&lang=js"
import style0 from "./vip-birthday-gift.vue?vue&type=style&index=0&id=2388562c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388562c",
  null
  
)

export default component.exports